<template >
  <v-list-item :key="item.title">
    <template v-slot:default="{ active, toggle }">
      <v-list-item-icon>
        <v-icon class="handle px-2">fa-grip-vertical</v-icon>
      </v-list-item-icon>
      <v-list-item-icon>
        <v-icon>{{ icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content class="ml-5">
        <v-list-item-title v-text="item.title"></v-list-item-title>
        <v-list-item-subtitle class="text--primary">{{ item.description }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon color="error" class="px-2" @click="removeAsset">fa-times</v-icon>
      </v-list-item-action>
    </template>
  </v-list-item>
</template>
<script>
import courseAPI from "@/api/course.js";
export default {
  name: "SortCourseMaterialListItem",
  props: {
    item: {
      type: Object,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    index: {
      type: Number,
      default: null
    }
  },
  computed: {
    mimeType() {
      return this.item.file ? this.item.file.hasOwnProperty("data")
        ? this.item.file.data.mime_type
        : this.item.file.mime_type
        : 'link';
    },
    icon() {
      var icon = '';
      switch (this.mimeType) {
        case "link":
          icon = "fa-link";
          break;
        case "video/mp4":
          icon = "fa-video";
          break;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          icon = "fa-file-word";
          break;
        case "image/jpeg":
        case "image/png":
          icon = "fa-image";
          break;
        case "application/pdf":
          icon = "fa-file-pdf";
          break;
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          icon = 'fa-file-ppt';
          break;
        case 'application/x-zip-compressed':
          icon = 'fa-photo-film-music';
          break;  
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          icon = 'fa-file-spreadsheet';
          break;    
        default:
          icon = "fa-file";
          break;
      }
      return icon;
    }
  },
  methods: {
    removeAsset() {
      courseAPI.removeCourseMaterial(this.id, this.item.id).then(() => {
        this.$store.dispatch("removeCourseMaterials", this.index);
      });
    }
  }
};
</script>
